import React from "react";

import { NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";
import { getNRErrorInfo } from "@swiggy-private/js-utils";

const EVENT_TYPE = NEWRELIC_TABLES.PL_BILL_DETAILS_EVENTS;

enum PLBillDetailsNRState {
    ERROR_BOUNDARY = "error_boundary",
    DATA_PRESENT = "data_present",
}

export function recordPLBillDetailsError(error?: Error, errorInfo?: React.ErrorInfo): void {
    const errorEvents = getNRErrorInfo(error, errorInfo);

    recordNREvent({
        eventType: NEWRELIC_TABLES.CHECKOUT_WEB_ERROR_BOUNDARY,
        widgetType: "PL_BILL_DETAILS_RENDERER",
        ...errorEvents,
    });

    recordNREvent({
        eventType: EVENT_TYPE,
        state: PLBillDetailsNRState.ERROR_BOUNDARY,
        ...errorEvents,
    });
}

export function recordPLBillDetailsDataPresent({
    hasCollapsedData,
    hasUncollapsedData,
}: {
    hasCollapsedData: boolean;
    hasUncollapsedData: boolean;
}): void {
    recordNREvent({
        eventType: EVENT_TYPE,
        state: PLBillDetailsNRState.DATA_PRESENT,
        hasCollapsedData: String(hasCollapsedData),
        hasUncollapsedData: String(hasUncollapsedData),
    });
}
